import isWithinRange from 'date-fns/is_within_range'

export const shouldShowHiatusNotice = dateRange => isWithinRange(new Date(), dateRange.start, dateRange.end)
